import { render } from "./ContractVehiclesSectionComponent.vue?vue&type=template&id=4036fb70&scoped=true&ts=true"
import script from "./ContractVehiclesSectionComponent.vue?vue&type=script&lang=ts"
export * from "./ContractVehiclesSectionComponent.vue?vue&type=script&lang=ts"

import "./ContractVehiclesSectionComponent.vue?vue&type=style&index=0&id=4036fb70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4036fb70"]])

export default __exports__